// Pricing data
export interface PricingTier {
    value: string;
    label: string;
    monthly: number | null;
    annual: number | null;
    storage: string;
    custom?: boolean;
    popular?: boolean;
    yearlySalePrice?: number;
    automatedValue?: string;
}

export const automatedPriceMonthly = {
    "200": { price: 49, webinars: 2, storage: "2 GB" },
    "500": { price: 79, webinars: 2, storage: "5 GB" },
    "3000": { price: 143, webinars: 4, storage: "10 GB" },
    "6000": { price: 242, webinars: 4, storage: "10 GB" },
    "10000": { price: 396, webinars: 6, storage: "10 GB" },
    "10000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const automatedPriceYearly = {
    "200": { price: 41, webinars: 2, storage: "2 GB" },
    "500": { price: 66, webinars: 2, storage: "5 GB" },
    "3000": { price: 119, webinars: 4, storage: "10 GB" },
    "6000": { price: 201, webinars: 4, storage: "10 GB" },
    "10000": { price: 330, webinars: 6, storage: "10 GB" },
    "10000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const allInOnePriceMonthly = {
    "100": { price: 116, webinars: 3, storage: "2 GB" },
    "300": { price: 198, webinars: 3, storage: "5 GB" },
    "1000": { price: 396, webinars: 3, storage: "10 GB" },
    "3000": { price: 299, webinars: 6, storage: "10 GB" },
    "6000": { price: 449, webinars: 6, storage: "10 GB" },
    "6000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const allInOnePriceYearly = {
    "100": { price: 96, webinars: 3, storage: "2 GB" },
    "300": { price: 165, webinars: 3, storage: "5 GB" },
    "1000": { price: 330, webinars: 3, storage: "10 GB" },
    "3000": { price: 249, webinars: 6, storage: "10 GB" },
    "6000": { price: 374, webinars: 6, storage: "10 GB" },
    "6000+": { price: "**", webinars: "6+", storage: "Custom" }
};


export const LIVE_PRICES: PricingTier[] = [
    { value: '50', label: '50 Attendees', monthly: 44, annual: 36, yearlySalePrice: 44, storage: '2GB' },
];

export const AUTOMATED_PRICES: PricingTier[] = [
    { value: '3000', label: '3000 Attendees', monthly: 144, annual: 119, yearlySalePrice: 144, storage: '10GB' },
    { value: '6000', label: '6000 Attendees', monthly: 242, annual: 201, yearlySalePrice: 242, storage: '10GB' },
    { value: '10000', label: '10000 Attendees', monthly: 396, annual: 330, yearlySalePrice: 396, storage: '10GB' },
];

export const LIVE_AUTO_PRICES: PricingTier[] = [
    { value: '200', automatedValue: '1000', label: '50 Live & 200 Automated', monthly: 116, annual: 96, yearlySalePrice: 116, storage: '2GB' },
    { value: '500', automatedValue: '2500', label: '250 Live & 500 Automated', monthly: 198, annual: 165, yearlySalePrice: 198, storage: '5GB' },
    { value: '1000', automatedValue: '5000', label: '500 Live & 3,000 Automated', monthly: 396, annual: 330, yearlySalePrice: 396, storage: '10GB', popular: true },
]; 